export default class BankDetails {
  private _name!: string
  private _iban!: string

  constructor(data: Partial<BankDetails> = {}) {
    this.name = data.name
    this.iban = data.iban
  }

  get name(): string {
    return this._name
  }

  set name(value: string | undefined) {
    this._name = value ?? ''
  }

  get iban(): string {
    return this._iban
  }

  set iban(value: string | undefined) {
    this._iban = value ?? ''
  }

  updateAttributes(newAttributes: Partial<BankDetails>) {
    Object.assign(this, newAttributes)
  }
}
